import { z } from 'zod';
import type { EnterpriseTeam, EnterpriseWorkspace } from './enterprise.api';

const nullableString = z.string().nullable();

export const enterpriseWorkspace$ = z.object({
  id: z.number().int(),
  slug: z.string(),
  name: z.string(),
  organizationId: z.string(),
  iconUrl: nullableString,
  archived: z.boolean(),
  createdAt: z.union([z.string(), z.date()]).nullable().optional(),
  updatedAt: z.union([z.string(), z.date()]).nullable().optional()
});

export const enterpriseTeam$ = z.object({
  id: z.number().int(),
  slug: z.string(),
  name: z.string(),
  organizationId: z.string(),
  workspaceId: z.number().int(),
  iconUrl: nullableString,
  iconColor: nullableString,
  archived: z.boolean(),
  createdAt: z.union([z.string(), z.date()]).nullable().optional(),
  updatedAt: z.union([z.string(), z.date()]).nullable().optional()
});

export type EnterpriseWorkspaceHttp = z.infer<typeof enterpriseWorkspace$>;
export type EnterpriseTeamHttp = z.infer<typeof enterpriseTeam$>;

export function enterpriseWorkspaceFromHttp(
  dto: EnterpriseWorkspaceHttp,
  orgWorkspaceId: string
): EnterpriseWorkspace {
  return {
    id: dto.id,
    slug: dto.slug,
    organizationId: orgWorkspaceId,
    name: dto.name,
    iconUrl: dto.iconUrl ?? '',
    archived: dto.archived
  };
}

export function enterpriseTeamFromHttp(
  dto: EnterpriseTeamHttp,
  _orgWorkspaceId: string
): EnterpriseTeam {
  return {
    id: dto.id,
    slug: dto.slug,
    workspaceId: dto.workspaceId,
    name: dto.name,
    iconUrl: dto.iconUrl ?? '',
    iconColor: dto.iconColor ?? '',
    archived: dto.archived
  };
}
